import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import { Row } from 'react-styled-flexboxgrid';
import { rem } from 'polished';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const HeadingRow = styled(Row)`
  color: ${theme('colors.white')};
  h4 {
    color: ${theme('colors.white')};
    font-size: ${rem(20)};
    line-height: ${rem(28)};
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 7rem;
  }
`;

const ResponsiveGridWhite = styled(ResponsiveGrid)`
  background-color: ${theme('colors.white')};
  padding-top: 4rem;
  padding-bottom: 4rem;
`;

const BodyRow = styled(Row)`
  background-color: ${theme('colors.white')};
  padding-bottom: 4rem;
`;

export { HeadingRow, ResponsiveGridWhite, BodyRow };
